// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1wuYJ","select":"Header_select__2eu7h","clinic":"Header_clinic__2_-ZD"};